module.exports = "<canvas data-no-op-canvas></canvas>\n<p data-no-op-msg>Your browser does not support the playback of this video. Try to use a different browser.<p>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/no_op/public/error.html
 ** module id = 142
 ** module chunks = 0
 **/